export const authorizationActions = {
  changeFetchingStatus: 'AUTHORIZATION_SET_FETCHING_STATUS',
  changeIsRestoringSession: 'AUTHORIZATION_SET_IS_RESTORING_SESSION',
  setPhoneNumber: 'AUTHORIZATION_SET_PHONE_NUMBER',
  setUserToken: 'AUTHORIZATION_SET_TOKEN',
  setClient: 'AUTHORIZATION_SET_CLIENT',
  updateClient: 'AUTHORIZATION_UPDATE_CLIENT',
  handlePaymentAuthorizedModal: 'AUTHORIZATION_HANDLE_PAYMENT_AUTHORIZED_MODAL',
  setTerms: 'AUTHORIZATION_SET_TERMS',
  logout: 'AUTHORIZATION_LOGOUT',
};

export const  authorizationActionCreators = {
  changeFetchingStatus: (isFetching) => ({
    type: authorizationActions.changeFetchingStatus,
    payload: { isFetching },
  }),
  restoreSession: (isRestoringSession) => ({
    type: authorizationActions.changeIsRestoringSession,
    payload: { isRestoringSession },
  }),
  setPhoneNumber: (phone = '') =>  ({
    type: authorizationActions.setPhoneNumber,
    payload: phone ,
  }),
  setUserToken: (token) => ({
    type: authorizationActions.setUserToken,
    payload: { token },
  }),
  setClient: (client) => ({
    type: authorizationActions.setClient,
    payload: { client },
  }),
  updateClient: (client) => ({
    type: authorizationActions.updateClient,
    payload: client,
  }),
  setTerms: (termAndPolicyAgreed) => ({
    type: authorizationActions.setTerms,
    payload: { termAndPolicyAgreed },
  }),
  handlePaymentAuthorizedModal: () => ({
    type: authorizationActions.handlePaymentAuthorizedModal,
  }),
  logout: (skipRequest) => ({
    type: authorizationActions.logout,
    payload: { skipRequest },
  }),
};
